import { createFileRoute } from "@tanstack/react-router";
import { LabsArticle } from "~/components/labs/LabsExperience";
import { loadEngineeringPost } from "~/utils/content-fns";
import { seo, seoLinks } from "~/utils/seo";

export const Route = createFileRoute("/labs/research/$slug")({
  loader: ({ params }) => loadEngineeringPost({ data: { slug: params.slug } }),
  head: ({ loaderData }) => ({
    meta: loaderData
      ? seo({
          title: loaderData.seo_title || loaderData.title,
          description: loaderData.seo_description || loaderData.description,
          image: loaderData.featured_image,
          url: `/labs/research/${loaderData.slug}`,
          type: "article",
          publishedTime: loaderData.date,
          modifiedTime: loaderData.last_updated,
          authors: loaderData.authors,
          section: loaderData.categories[0] ?? null,
        })
      : [],
    links: loaderData ? seoLinks({ url: `/labs/research/${loaderData.slug}` }) : [],
  }),
  component: ResearchArticle,
});

function ResearchArticle() {
  return <LabsArticle post={Route.useLoaderData()} />;
}
